// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"5950e626","542":"3f362f64","977":"3003e5f4"}[chunkId] + ".chunk.js";
};